/**
 * Class with common functionality for DataPages
 */

class DataPages {
    /**
     * Content position attribute
     */

    CONTENT_POSITION_INIT = 'data-content-position="init"';
    CONTENT_POSITION_FILTERED = 'data-content-position="content"';
    CONTENT_POSITION_GRID = 'data-content-position="grid"';

    /**
     * Data attribute table
     * @type {String}
     */

    DATA_PAGE_TABLE_ATTRIBUTE = 'data-page-table';

    constructor() {
        //
    }

    /**
     * Init and validate HTML variables
     *
     * @return {Boolean}
     */

    _initAndValidateHTMLVariables() {
        this._content_position_init = this._validateHtmlElement(
            `[${this.CONTENT_POSITION_INIT}]`,
        );

        this._content_position_filtered = this._validateHtmlElement(
            `[${this.CONTENT_POSITION_FILTERED}]`,
        );

        this._content_position_grid = this._validateHtmlElement(
            `[${this.CONTENT_POSITION_GRID}]`,
        );

        this._table_container = this._validateHtmlElement(
            `[${this.DATA_PAGE_TABLE_ATTRIBUTE}]`,
        );

        //
        this.wrapper = this._table_container.closest('.js-data-page-wrapper');
        this.loader = this.wrapper.querySelector('.h-loader');

        return !!(
            this._content_position_init &&
            this._content_position_filtered &&
            this._content_position_grid &&
            this._table_container &&
            this.wrapper
        );
    }

    /**
     * Validate HTML element use selector. Return element(s) or null
     *
     * @param {String} selector - Selector for element(s)
     * @param {Boolean} all - Use querySelectorAll? Default: false
     * @return {Array.<HTMLElement>|HTMLElement|null}
     *
     * @private
     */
    _validateHtmlElement(selector, all = false) {
        let result;

        if (all) {
            result = document.querySelectorAll(`${selector}`);
        } else {
            result = document.querySelector(`${selector}`);
        }

        // if (!result) {
        // console.error(
        //     `DataPages: Element with selector ${selector} not found on page. This is critical for the correct operation of the page.`,
        // );
        // }

        return result;
    }

    pageInitialized() {
        const gridContainer = this._table_container;
        const selectsWrapper = gridContainer.closest('.js-data-page-wrapper');

        selectsWrapper.classList.add('initialized');
    }

    initializationEnds(rowsAvailable = false) {
        if (rowsAvailable) {
            this._content_position_init.classList.add('hidden');
            this._content_position_filtered.classList.remove('hidden');
            this._content_position_grid.classList.remove('hidden');
        }
    }

    showStartContent() {
        this._content_position_init.classList.remove('hidden');
        this._content_position_filtered.classList.add('hidden');
        this._content_position_grid.classList.add('hidden');
    }

    setLoaders() {
        if (this.wrapper) {
            const height = this.wrapper.clientHeight;
            this.wrapper.style.height = `${height}px`;
        }
        if (this.loader) {
            this.loader.classList.remove('!hidden');
        }
        //
        document.body.classList.add('dp__loading');
    }

    removeLoaders() {
        if (this.wrapper) {
            this.wrapper.style.height = '';
        }
        if (this.loader) {
            this.loader.classList.add('!hidden');
        }
        //
        document.body.classList.remove('dp__loading');
    }
}
export default DataPages;
